export default {
  paused: 'Onlinebetalinger er sat på pause på grund af problemer med KYC-verificeringen.',
  deadline_warning: 'KYC-verificering er påkrævet, ellers sættes onlinebetalinger på pause den {{date}}.',
  complete_verification: 'Fuldfør verificering',
  partner: {
    action_needed: 'Din betalingsudbyder mangler en sidste ting, før denne restaurant kan modtage onlinebetalinger.',
    hosted_incomplete: 'Du har endnu ikke fuldført opsætningen af onlinebetalinger hos din betalingsudbyder.',
    link_expired: 'Dit link til at fuldføre opsætningen af onlinebetalinger er udløbet. Få et nyt, og fortsæt.',
    open_error: 'Der kunne ikke oprettes forbindelse til betalingsudbyderen. Prøv igen om nogle minutter.',
    hosted_not_started: 'Onlinebetalinger er endnu ikke opsat hos din betalingsudbyder.',
    business_details_missing: 'Tilføj dine virksomhedsoplysninger for at begynde at modtage onlinebetalinger.',
    continue: 'Fortsæt',
  },
};
